/* eslint-disable react/no-array-index-key -- spreadsheet rows and cells have no stable id and are never reordered; position is the identity */
import { bodySmall } from '@monorepo/shared/styles/text';
import React from 'react';
import styled from 'styled-components';
import { StyledPreviewMessage } from './styled';
import { SpreadsheetSheet } from './types';

const StyledTruncatedNotice = styled.p`
  ${bodySmall}
  padding: 0.5rem;
  margin: 0;
  color: ${({ theme }) => theme.colors.gray666};
`;

const StyledTable = styled.table`
  ${bodySmall}
  border-collapse: collapse;

  th,
  td {
    padding: 0.25rem 0.5rem;
    white-space: nowrap;
    border: 1px solid ${({ theme }) => theme.colors.grayddd};
  }

  th {
    position: sticky;
    top: 0;
    font-weight: inherit;
    text-align: inherit;
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

type SheetTableProps = {
  sheet: SpreadsheetSheet;
  ariaLabel: string;
};

export function SheetTable({ sheet, ariaLabel }: SheetTableProps) {
  const [headerRow = [], ...bodyRows] = sheet.rows;
  if (!headerRow.length) {
    return <StyledPreviewMessage>This sheet is empty.</StyledPreviewMessage>;
  }

  return (
    <>
      {sheet.isTruncated && (
        <StyledTruncatedNotice>
          Showing the first {sheet.rows.length} rows of {sheet.name}.
        </StyledTruncatedNotice>
      )}
      <StyledTable aria-label={ariaLabel}>
        <thead>
          <tr>
            {headerRow.map((cell, columnIndex) => (
              <th key={columnIndex} scope="col">
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {bodyRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headerRow.map((_, columnIndex) => (
                <td key={columnIndex}>{row[columnIndex] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </>
  );
}
